{
  "done": "Done",
  "cancel": "Cancel",
  "none": "None",
  "delete": "Delete item",
  "add_freq_warning": {
    "title": "Adding recurrence to this item will remove your existing message",
    "confirm": "Continue"
  },
  "date": {
    "sheet_title": "Date",
    "indefinitely": "Indefinitely",
    "aria": {
      "start": "Start date",
      "end": "End date",
      "until": "Until date"
    }
  },
  "time": {
    "sheet_title": "Time",
    "placeholder": "Time",
    "add": "Add time",
    "remove": "remove",
    "aria": {
      "start": "Start time",
      "end": "End time"
    }
  },
  "location": {
    "placeholder": "Where",
    "aria": "Location",
    "menu": {
      "edit": "Edit",
      "open": "Open in maps"
    }
  },
  "title": {
    "placeholder": "Add title"
  },
  "description": {
    "placeholder": "Item details..."
  },
  "emoji": {
    "sheet_title": "Emoji"
  },
  "when": {
    "sheet_title": "When",
    "message_alert": "Changing recurrence will remove all existing messages for all instances in this series",
    "rsvp_alert": "Disable RSVP to add recurrence"
  },
  "category": {
    "sheet_title": "Category",
    "placeholder": "Category",
    "assigned": "Category: {{value}}"
  },
  "label": {
    "placeholder": "Labels",
    "sheet_title": "Labels",
    "assigned": "Labels: {{values}}"
  },
  "who": {
    "placeholder": "Who",
    "sheet_title": "Who",
    "assigned": "Who: {{values}}"
  },
  "visibility": {
    "assigned": "Visibility: {{value}}",
    "hidden": "Hidden",
    "visible": "Visible"
  },
  "shading": {
    "assigned": "Shading: {{value}}",
    "notShaded": "Not Shaded",
    "shaded": "Shaded"
  },
  "feed": {
    "imported_from": "Added from {{feed}}",
    "notes_placeholder": "Item notes..."
  },
  "inline": {
    "more": "More",
    "title_placeholder": "Title",
    "toolbar_aria": {
      "emoji": "Choose an emoji",
      "category": "Choose a category",
      "when": "Choose when the item occurs",
      "location": "Choose a location",
      "who": "Choose who the item concerns",
      "labels": "Choose labels"
    }
  },
  "messages_panel": {
    "button_label": "Texts",
    "header": "Text messages",
    "entry_in_past_text": "No messages can be added to this item because it's in the past",
    "recurrence_not_supported": {
      "paragraph_one": "Message support for recurring items is still under development",
      "paragraph_two": "Until this feature is ready, you can still add a message to items in the series by first saving the item, and then clicking into an individual instance to configure a message."
    },
    "empty_state": {
      "body": "Text messages are a powerful way to keep people up-to-date with your schedule!",
      "call_to_action": "Add text"
    },
    "upgrade_state": {
      "body": "Text messages are a powerful way to keep people up-to-date with your schedule! Upgrade to Plus to unlock this feature!",
      "call_to_action": "Upgrade to Plus",
      "schedule_more": "Want to schedule more text messages? Upgrade to Plus to continue using this feature."
    },
    "add_another_message": "Add another message",
    "error_saving_item_toast": "Error saving item",
    "error_deleting_message_toast": "Error deleting message",
    "reached_message_limit_tooltip": "You've scheduled the maximum number of messages for this item, please delete a message to schedule another"
  },
  "rsvps_panel": {
    "header": "RSVP",
    "button_label": "RSVPs",
    "toggle_label": "Enable RSVP",
    "toggle_error_toast": "Error enabling RSVP",
    "empty_state_text": "Find out if people are going to this event by adding an RSVP!",
    "going": "Going",
    "not_going": "Not going",
    "empty_state": "No one has RSVP'd yet!",
    "recurrence_unsupported": "RSVP is not currently supported for recurring items",
    "question": "Question text",
    "confirm_label": "Confirm label",
    "decline_label": "Decline label",
    "settings": "Settings",
    "settings_error": "Unable to update RSVP settings, please try again"
  },
  "create": {
    "toast": "Added {{title}}",
    "error": "Error creating event",
    "messages_error_one": "Your event was created, but 1 of {{total}} text reminders couldn't be scheduled",
    "messages_error_other": "Your event was created, but {{count}} of {{total}} text reminders couldn't be scheduled"
  },
  "duplicate": {
    "label": "Duplicate item",
    "loading": "Duplicating...",
    "done": "Item duplicated!",
    "toast": "Now editing {{title}}",
    "suffix": "{{title}} (copy)",
    "error": "Error duplicating item"
  },
  "advanced": {
    "showLabel": "Show advanced options",
    "hideLabel": "Hide advanced options"
  },
  "confirm_close_dialog": {
    "title": "You have an unsaved message",
    "message": "Please cancel or save your message before saving this item",
    "action": "Go back"
  }
}
